import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import {
  FormControl,
  Select,
  Input,
  InputLabel,
  ListItemText
} from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GochiMenuAddConfirmShop from './GochiMenuAddConfirmShop';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import {
  getGochiMenus,
  addGochiMenu,
  addGochiMenuImage
} from '../../actions/GochiMenus';
// import { getShops } from '../../actions/Shop';
import { getOptionGroups, getOptionShops } from '../../actions/Options';
import ValidationText from '../../components/atoms/ValidationText';
import { languages, languageType } from '../../constants/Language';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = theme => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 20
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px',
    width: '100%'
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  listForm: {
    display: 'block'
  },
  itemForm: {
    display: 'block',
    padding: '20px 20px 12px',
    borderBottom: '1px solid #DDDDDD'
  },
  textExplain: {
    fontSize: 12
  },
  btnBtom: {
    padding: '0 12px 10px 12px'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  displayFlex: {
    display: 'flex',
    alignItems: 'flex-end'
    // [theme.breakpoints.down('sm')]: {
    //   display: 'flex',
    //   border: 0,
    //   paddingTop: 0
    // }
  },
  displayFlexPulldown: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%'
  },
  displayBlock: {
    display: 'block'
  },
  textYen: {
    width: '30px',
    paddingBottom: 4
  },
  textMutiple: {
    // width: '52px',
    fontWeight: 'bold',
    fontSize: 19,
    paddingLeft: 10,
    paddingRight: 10
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  divisionLabel: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.38)',
    marginTop: 16
  },
  divHelp: {
    marginRight: 'auto'
  },
  iconHelpEx: {
    color: 'gray !important'
  },
  divExplanation: {
    position: 'absolute',
    width: 280,
    top: 53,
    right: 21,
    zIndex: 10
  },
  textHelpExplainDiv: {
    padding: '10px 10px 0 10px'
  },
  textHelpExplain: {
    fontSize: 10
  },
  helpCloseBtn: {
    fontSize: 18,
    position: 'absolute',
    top: 3,
    right: 4
  },
  helpCloseBtnWhite: {
    color: '#fff !important'
  },
  explainExpirationTitle: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  situationPulldown: {
    width: '100%',
    margin: '16px 0px 8px'
  },
  pulldownHeight: {
    maxHeight: '350px'
  },
  fukuokaTextPrice: {
    color: '#F50057',
    fontSize: '14px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix,
      languages
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          addGochiMenu,
          addGochiMenuImage,
          getOptionGroups,
          getOptionShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('countChildGroups', 'updateCountChildGroups', 1),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopIdAdd', 'setShopIdAdd', 0),
  withState('menuChildType', 'setMenuChildType', 1),
  withState('comboMenu', 'setComboMenu', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupsError', 'setGroupsError', ''),
  withState('groups', 'setGroups', []),
  withState('shops', 'setShops', []),
  withState('shopName', 'setShopName', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expirationType', 'setExpirationType', 2),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 1; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 0; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('helpPriceCombo', 'setHelpPriceCombo', false),
  withState('helpQuantityPromotion', 'setHelpQuantityPromotion', false),
  withState('helpPromotionDescription', 'setHelpPromotionDescription', false),
  withState('helpExpiration', 'setHelpExpiration', false),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscription', 'setSubscription', 0),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionGroups().then(data => {
        this.props.checkSession(data);
        this.props.setGroups(data.payload.list);
        this.props.updateCountChildGroups(
          data.payload.list.filter(
            item =>
              item.isAllowCreateChildMenu === 1 &&
              item.groupType.toUpperCase() === 'OTHERS'
          ).length
        );
      });
      this.props.actions.getOptionShops().then(data => {
        this.props.checkSession(data);
        this.props.setShops(data.payload.list);
      });
      let dataFirst = {};
      const origilData = {
        menuChildType: null,
        groupId: null,
        shopId: null,
        shopName: null,
        menuName: null,
        menuLimitTotal: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        price: null,
        description: null,
        menuCombo: null,
        priceCombo: null,
        quantity: null,
        quantityFree: null,
        quantityFreeDes: null,
        numberUsePerDay: null,
        expiration: null,
        expirationEndDate: null,
        taxType: null,
        reducedTaxType: null,
        tags: null,
        tagStr: null,
        menuGenreId: null,
        menuGenreName: null,
        menuSituationIds: [],
        menuSituationNames: null,
        menuUserTargetIds: [],
        menuUserTargetNames: null
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);
      console.log('dataFirst', dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    checkSession,
    searchKey,
    roles,
    openAddConfirm,
    updateOpenAdd,
    updateOpenAddConfirm,
    openAddProgress,
    updateOpenAddProgress,
    loading,
    updateLoading,
    isAddSuccess,
    updateIsAddSuccess,
    resultMessage,
    setResultMessage,
    groupsError,
    setGroupsError,
    groupId,
    setGroupId,
    groups,
    shopId,
    setShopId,
    shopIdAdd,
    // setShopIdAdd,
    shopName,
    setShopName,
    shops,
    menuName,
    setMenuName,
    comboMenu,
    setComboMenu,
    menuLimitTotal,
    setMenuLimitTotal,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    quantityReleaseList,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    usageLimit,
    setUsageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expirationType,
    setExpirationType,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    setExpirationEndDate,
    minExpirationDate,
    maxExpirationDate,
    expirationList,
    subscriptionInterval,
    setSubscriptionInterval,
    subscriptionIntervalCount,
    setSubscriptionIntervalCount,
    subscription,
    setSubscription,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    subscripIntervalCountError,
    setSubscripIntervalCountError,
    reducedTaxType,
    setReducedTaxType,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    reducedTaxMenuPrefix,
    shopNameError,
    setShopNameError,
    menuNameError,
    setMenuNameError,
    priceError,
    setPriceError,
    handleChangePage,
    menuChildType,
    setMenuChildType,
    helpPriceCombo,
    setHelpPriceCombo,
    helpQuantityPromotion,
    setHelpQuantityPromotion,
    helpPromotionDescription,
    setHelpPromotionDescription,
    helpExpiration,
    setHelpExpiration,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreError,
    setMenuGenreError,
    isFukuoka
  }) => {
    const errors = {
      groupsError,
      shopNameError,
      menuNameError,
      priceError,
      priceComboError,
      subscripIntervalCountError,
      quantityReleaseError,
      quantityPromotionError,
      expirationError,
      menuGenreError
    };
    const validGroups = () => {
      const value = groupId;
      if ((menuChildType === 3 || menuChildType === 4) && value === 0) {
        setGroupsError('必須項目です。');
        return 1;
      }
      setGroupsError('');
      setGroupId(value);
      return 0;
    };
    const validShopName = () => {
      const value = shopId;
      if (
        menuChildType !== 3 &&
        menuChildType !== 4 &&
        value === 0 &&
        isLanguage !== languageType.ORIGIN
      ) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopId(value);
      return 0;
    };
    const validMenuName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };
    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        if (!isFukuoka) {
          setMenuGenreError('必須項目です。');
          return 1;
        }
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };
    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };
    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };
    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };
    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '') {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };
    const validSubscriptionIntervalCount = () => {
      const checkSubscription = subscription;
      if (checkSubscription === 1) {
        const valueIntervalCount = subscriptionIntervalCount;
        const valueInterval = subscriptionInterval;
        if (valueIntervalCount === '') {
          setSubscripIntervalCountError('必須項目です。');
          return 1;
        }
        if (Number(valueIntervalCount) < 1) {
          setSubscripIntervalCountError('頻度価値は1以上ご入力ください');
          return 1;
        }
        if (!/^\d+$/.test(valueIntervalCount)) {
          setSubscripIntervalCountError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueInterval === 'WEEK' && Number(valueIntervalCount) > 52) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
        if (valueInterval === 'MONTH' && Number(valueIntervalCount) > 12) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
      }
      setSubscripIntervalCountError('');
      return 0;
    };
    const validExpiration = () => {
      const value = expiration;
      if (value === '') {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      // Menu normal
      if (comboMenu === 0) {
        errorCount =
          validShopName() +
          validMenuName() +
          validPrice() +
          validSubscriptionIntervalCount() +
          validGroups() +
          validMenuGenre();
      } else if (comboMenu === 1) {
        // Menu combo
        errorCount =
          validShopName() +
          validMenuName() +
          // validPrice() +
          validGroups() +
          validPriceCombo() +
          validSubscriptionIntervalCount() +
          validQuantityRelease() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre();
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const resetPriceComboValue = () => {
      setPrice('');
      setPriceError('');
      setPriceCalc('000 (税込み)');
      setPriceCombo('');
      setQuantityRelease('');
      setQuantityPromotion('');
      setPromotionDescription('');
      setUsageLimit(0);
      setExpirationType(2);
      setExpiration('');
      setExpirationEndDate('');
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const calcPrice = e => {
      let includedTaxPrice = '';
      let excludedTaxPrice = '';

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }
      console.log(excludedTaxPrice);
      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log('e.target.id', e.target.id);
      const val =
        e.target.id !== 'reducedTax' && typeof e.target.id !== 'undefined'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType,
        groupId,
        shopId: shopIdAdd || shopId,
        shopName,
        menuName,
        price,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        description,
        menuCombo: isFukuoka ? 0 : comboMenu,
        menuLimitTotal: comboMenu === 0 ? menuLimitTotal : undefined,
        priceCombo,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expiration,
        expirationEndDate,
        taxType,
        reducedTaxType,
        tags,
        tagStr,
        previewImage,
        menuGenreId: isFukuoka
          ? menuGenre.find(
              genre => genre.menuGenreName.toString() === '飲食店以外'
            ).menuGenreId
          : menuGenreId,
        menuSituationIds,
        menuUserTargetIds
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      console.log('GET CURRENT DATA: ', data);
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const getSituationName = () => {
      const situationName = [];
      if (menuSituationIds.length) {
        menuSituationIds.forEach(id => {
          const name = menuSituation.find(
            situation => situation.menuSituationId.toString() === id.toString()
          ).menuSituationName;
          situationName.push(name);
        });
        return situationName.join(', ');
      }
      return '';
    };

    const getUserTargetName = () => {
      const userTargetName = [];
      if (menuUserTargetIds.length) {
        menuUserTargetIds.forEach(id => {
          const names = menuUserTarget.find(
            userTarget =>
              userTarget.menuUserTargetId.toString() === id.toString()
          ).name;
          userTargetName.push(names);
        });
        return userTargetName.join(', ');
      }
      return '';
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };
    const setShopNameData = id => {
      shops.forEach(item => {
        if (id === item.shopId) {
          setShopName(item.shopName);
        }
      });
    };

    const cancelAction = () => updateOpenAdd(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMenuSituationNames(getSituationName());
        setMenuUserTargetNames(getUserTargetName());
        setShopNameData(shopId);
        setMultiLangData(getCurrentData());
        updateOpenAddConfirm(true);
      }
    };
    const backAction = () => updateOpenAddConfirm(false);
    const registerAction = async () => {
      updateLoading(true);
      updateOpenAddProgress(true);
      let params = {};
      if (account.fukuokaFlag) {
        params = {
          ...multiLangData,
          shashokuOn: 1,
          gochimeshiOn: 0
        };
      } else {
        params = {
          ...multiLangData,
          shashokuOn:
            !multiLangData.menuCombo && !multiLangData.menuLimitTotal ? 1 : 0
        };
      }
      const addedMenu = await actions
        .addGochiMenu(params)
        .then(data => checkSession(data));
      if (image !== null) {
        let imageData = image;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile(
          'menu',
          addedMenu.payload.menuId,
          imageData,
          'public'
        );
        actions
          .addGochiMenuImage(addedMenu.payload.menuId, {
            image: imagePath
          })
          .then(data => checkSession(data));
      }
      if (addedMenu.type === 'ADD_GOCHI_MENU_SUCCESS') {
        updateIsAddSuccess(true);
        actions.getGochiMenus(searchKey).then(data => checkSession(data));
        setResultMessage('登録が完了しました。');
        updateLoading(false);
      } else {
        updateIsAddSuccess(false);
        setResultMessage('登録に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isAddSuccess) {
        updateOpenAdd(false);
        updateOpenAddConfirm(false);
        updateOpenAddProgress(false);
        handleChangePage(null, 1, 10);
      } else {
        updateOpenAddProgress(false);
      }
    };

    const getGroupOptions = () => {
      const groupOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (parseInt(menuChildType, 10) === 3) {
        groups
          .filter(
            item =>
              item.isAllowCreateChildMenu === 1 &&
              item.groupType.toUpperCase() === 'OTHERS'
          )
          .forEach(group => {
            groupOptions.push({
              label: group.groupName,
              value: String(group.groupId)
            });
          });
      }
      if (parseInt(menuChildType, 10) === 4) {
        groups
          .filter(item => item.groupType.toUpperCase() !== 'OTHERS')
          .forEach(group => {
            groupOptions.push({
              label: group.groupName,
              value: String(group.groupId)
            });
          });
      }
      return groupOptions.length > 0
        ? { ...groupOptions, tmpObj }
        : groupOptions;
    };

    const handleCloseHelpPopup = () => {
      setHelpPriceCombo(false);
      setHelpQuantityPromotion(false);
      setHelpPromotionDescription(false);
      setHelpExpiration(false);
    };

    const handleShowHelpPriceCombo = () => {
      setHelpPriceCombo(true);
    };

    const handleShowHelpQuantityPromotion = () => {
      setHelpQuantityPromotion(true);
    };

    const handleShowHelpPromotionDescription = () => {
      setHelpPromotionDescription(true);
    };

    const handleShowHelpExpiration = () => {
      setHelpExpiration(true);
    };

    const ref = useRef();

    const handleClose = e => {
      if (helpPriceCombo) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPriceCombo(false);
        }
      }
      if (helpQuantityPromotion) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpQuantityPromotion(false);
        }
      }
      if (helpPromotionDescription) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPromotionDescription(false);
        }
      }
      if (helpExpiration) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpExpiration(false);
        }
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClose);
      return () => {
        document.removeEventListener('click', handleClose);
      };
    });

    // setting language
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setMenuName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuName
                ? multiLangData.otherLanguages[k].params.menuName
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
            setPromotionDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.quantityFreeDes
                ? multiLangData.otherLanguages[k].params.quantityFreeDes
                : ''
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setMenuName(multiLangData.menuName);
        setDescription(multiLangData.description);
        setPromotionDescription(multiLangData.quantityFreeDes);
      }
      setIsLanguage(v);
      setMultiLangData(data);
      console.log('loc', data);
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">
            {isFukuoka ? 'コース情報編集' : '通常メニュー情報編集 '}
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <List component="nav" className={classes.listForm}>
            {roles.isShop && (
              <>
                <ListItem className={classes.itemForm}>
                  <Select
                    className={classes.textField}
                    value={isLanguage}
                    onChange={e => {
                      if (isLanguage === e.target.value) {
                        return;
                      }
                      if (
                        valid() ||
                        (isLanguage !== languageType.ORIGIN &&
                          translateType === 0)
                      ) {
                        setLanguage(e.target.value);
                      } else {
                        alert('登録情報を正しく入力してください。');
                      }
                    }}
                  >
                    {languages.map(lang => (
                      <MenuItem key={lang.value} value={lang.value}>
                        {lang.label}
                      </MenuItem>
                    ))}
                  </Select>
                </ListItem>
                {isLanguage !== languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography component="div" className={classes.formInput}>
                      <RadioGroup
                        value={translateType}
                        onChange={e => {
                          console.log('e', e.target.value);
                          setTranslateType(parseInt(e.target.value, 10));
                        }}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="GG翻訳を選択"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="自分で文章入力"
                        />
                      </RadioGroup>
                    </Typography>
                  </ListItem>
                )}
              </>
            )}
            {isLanguage === languageType.ORIGIN &&
              roles.isChildShopOnly &&
              !isFukuoka && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.labelControl}>
                    メニュー種別
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <RadioGroup
                      value={menuChildType}
                      onChange={e => {
                        setMenuChildType(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="通常"
                      />
                      <FormControlLabel
                        value={2}
                        control={<Radio color="primary" />}
                        label="こども食堂用(単独)"
                      />
                    </RadioGroup>
                  </Typography>
                </ListItem>
              )}
            {isLanguage === languageType.ORIGIN &&
              (parseInt(menuChildType, 10) === 3 ||
                parseInt(menuChildType, 10) === 4) &&
              !roles.isGroup && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <ReactSelectMaterialUi
                      required
                      label="所蔵グループ選択*"
                      className={classes.textField}
                      defaultValue={String(groupId)}
                      value={String(groupId)}
                      options={getGroupOptions()}
                      margin="normal"
                      onChange={v => {
                        setGroupId(Number(v));
                      }}
                      SelectProps={{
                        isClearable: true,
                        msgNoOptionsMatchFilter:
                          '名前が部分一致するグループがありません'
                      }}
                      onBlur={validGroups}
                    />
                    <ValidationText message={errors.groupsError} />
                  </Typography>
                </ListItem>
              )}

            {isLanguage === languageType.ORIGIN &&
              parseInt(menuChildType, 10) !== 3 &&
              parseInt(menuChildType, 10) !== 4 &&
              roles.isChildShop && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      required
                      select
                      label="店舗名"
                      className={classes.textField}
                      margin="normal"
                      value={shopId}
                      InputProps={{
                        readOnly: true
                      }}
                      variant="filled"
                    >
                      {shops.map(item => {
                        return (
                          <MenuItem key={item.shopId} value={item.shopId}>
                            {item.shopName}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Typography>
                </ListItem>
              )}
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <RequiredButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  required
                  label={isFukuoka ? 'コース名' : 'メニュー名'}
                  className={classes.textField}
                  margin="normal"
                  value={menuName}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 100 : 250
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  onChange={e => {
                    setMenuName(e.target.value);
                  }}
                  onBlur={validMenuName}
                />
                {(isLanguage === languageType.ORIGIN ||
                  translateType === 1) && (
                  <ValidationText message={errors.menuNameError} />
                )}
              </Typography>
            </ListItem>
            {isLanguage === languageType.ORIGIN && !isFukuoka && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    区分
                  </Typography>
                  <RadioGroup
                    row
                    value={comboMenu}
                    onChange={e => {
                      setComboMenu(parseInt(e.target.value, 10));
                      resetPriceComboValue();
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="回数券"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="普通"
                    />
                  </RadioGroup>
                </Typography>
              </ListItem>
            )}
            {comboMenu === 0 &&
              isLanguage === languageType.ORIGIN &&
              !isFukuoka && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <Typography className={classes.divisionLabel}>
                      利用方法
                    </Typography>
                    <RadioGroup
                      row
                      value={menuLimitTotal}
                      onChange={e => {
                        setMenuLimitTotal(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="一枚単位利用"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="一円単位利用"
                      />
                    </RadioGroup>
                  </Typography>
                </ListItem>
              )}
            {enabledStripeBilling === true && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    サブスクチケット利用する
                  </Typography>
                  <RadioGroup
                    row
                    value={subscription}
                    onChange={e => {
                      setSubscription(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="利用する"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="利用しない"
                    />
                  </RadioGroup>
                </Typography>
              </ListItem>
            )}
            {subscription === 1 && enabledStripeBilling === true && (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    購入頻度設定
                  </Typography>
                  <div className={classes.displayFlex}>
                    <div className={classes.displayFlex}>
                      <TextField
                        id="subscriptionIntervalCount"
                        required
                        label="頻度"
                        className={classes.textFieldPriceCombo}
                        margin="normal"
                        value={subscriptionIntervalCount}
                        onChange={e => {
                          setSubscriptionIntervalCount(e.target.value.trim());
                        }}
                        onBlur={validSubscriptionIntervalCount}
                      />
                    </div>
                    <div className={classes.displayFlexPulldown}>
                      <TextField
                        id="subscriptionInterval"
                        name="subscriptionInterval"
                        select
                        required
                        label="単位"
                        className={classes.textFieldPriceCombo}
                        margin="normal"
                        value={subscriptionInterval}
                        InputProps={{
                          shrink: true
                        }}
                        onChange={e => {
                          setSubscriptionInterval(e.target.value.trim());
                        }}
                      >
                        <MenuItem key="0" value="WEEK">
                          週間
                        </MenuItem>
                        <MenuItem key="1" value="MONTH">
                          ヶ月
                        </MenuItem>
                      </TextField>
                      <div className={classes.textYen}>1回</div>
                    </div>
                  </div>
                  <div className={classes.displayBlock}>
                    <ValidationText
                      message={errors.subscripIntervalCountError}
                    />
                  </div>
                </Typography>
              </ListItem>
            )}
            {comboMenu === 1 && (
              <>
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <div className={classes.displayFlex}>
                        <div className={classes.divHelp}>
                          <RequiredButton />
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpPriceCombo}
                        />
                        {helpPriceCombo && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CardMedia
                                component="img"
                                width="280"
                                className={classes.media}
                                image="images/help_comboPrice.png"
                                title="Menu price explaination"
                              />
                              <CloseIcon
                                className={[
                                  classes.helpCloseBtn,
                                  classes.helpCloseBtnWhite
                                ]}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography
                                  variant="body2"
                                  component="p"
                                  className={classes.textHelpExplain}
                                >
                                  メニュー名の後に表示される回数券の「単価」と「発行枚数」です。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <Typography className={classes.divisionLabel}>
                        単価×発行枚数
                      </Typography>
                      <div className={classes.displayFlex}>
                        <div className={classes.displayFlex}>
                          <TextField
                            id="priceCombo"
                            required
                            label="単価"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={priceCombo}
                            onChange={e => {
                              setPriceCombo(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validPriceCombo}
                          />
                        </div>
                        <div className={classes.textYen}>円</div>
                        <div className={classes.textMutiple}>×</div>
                        <div className={classes.displayFlexPulldown}>
                          <TextField
                            id="quantityRelease"
                            name="quantityRelease"
                            select
                            required
                            label="発行枚数"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={quantityRelease}
                            InputProps={{
                              shrink: true
                            }}
                            onChange={e => {
                              setQuantityRelease(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validQuantityRelease}
                          >
                            {quantityReleaseList.map(item => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                          <div className={classes.textYen}>枚</div>
                        </div>
                      </div>
                      <div className={classes.displayBlock}>
                        <ValidationText message={errors.priceComboError} />
                        <ValidationText message={errors.quantityReleaseError} />
                      </div>
                    </Typography>
                  </ListItem>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <div className={classes.displayFlex}>
                        <div className={classes.divHelp}>
                          <AnyButton />
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpQuantityPromotion}
                        />
                        {helpQuantityPromotion && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CardMedia
                                component="img"
                                width="280"
                                className={classes.media}
                                image="images/help_quantityPromotion.png"
                                title="Quantity promotion explaination"
                              />
                              <CloseIcon
                                className={[
                                  classes.helpCloseBtn,
                                  classes.helpCloseBtnWhite
                                ]}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography
                                  variant="body2"
                                  component="p"
                                  className={classes.textHelpExplain}
                                >
                                  メニュー画像とおまけの下の２箇所に表示される回数券の「付与無料枚数」です。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        id="quantityPromotion"
                        name="quantityPromotion"
                        select
                        label="付与無料枚数"
                        className={classes.textFieldLong}
                        margin="normal"
                        InputProps={{
                          shrink: true
                        }}
                        value={quantityPromotion}
                        onChange={e => {
                          setQuantityPromotion(e.target.value);
                        }}
                        onBlur={validQuantityPromotion}
                      >
                        {quantityReleaseList.map(item => {
                          return (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                      <ValidationText message={errors.quantityPromotionError} />
                    </Typography>
                  </ListItem>
                )}
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <div className={classes.displayFlex}>
                      <div className={classes.divHelp}>
                        <AnyButton />
                      </div>
                      <HelpIcon
                        className={classes.iconHelpEx}
                        onClick={handleShowHelpPromotionDescription}
                      />
                      {helpPromotionDescription && (
                        <div ref={ref} className={classes.divExplanation}>
                          <Card>
                            <CardMedia
                              component="img"
                              width="280"
                              className={classes.media}
                              image="images/help_quantityPromotionDescription.png"
                              title="Quantity promotion description explaination"
                            />
                            <CloseIcon
                              className={[
                                classes.helpCloseBtn,
                                classes.helpCloseBtnWhite
                              ]}
                              onClick={handleCloseHelpPopup}
                            />
                            <CardContent className={classes.textHelpExplainDiv}>
                              <Typography
                                variant="body2"
                                component="p"
                                className={classes.textHelpExplain}
                              >
                                メニューの説明文の下に表示される「おまけ」欄です。
                              </Typography>
                            </CardContent>
                          </Card>
                        </div>
                      )}
                    </div>
                  </Typography>
                  {/* quantityFreeDes input  */}
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      label="おまけ"
                      // multiline
                      // rows="3"
                      className={classes.textFieldLong}
                      margin="normal"
                      value={promotionDescription}
                      inputProps={{
                        maxLength:
                          isLanguage === languageType.ORIGIN ? 1000 : 2500
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                      onChange={e => {
                        setPromotionDescription(e.target.value);
                      }}
                    />
                  </Typography>
                </ListItem>
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography
                      component="div"
                      className={classes.divisionLabel}
                    >
                      利用制限
                    </Typography>
                    <RadioGroup
                      row
                      value={usageLimit}
                      onChange={e => {
                        setUsageLimit(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="1日1枚"
                      />
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="なし"
                      />
                    </RadioGroup>
                  </ListItem>
                )}
                {isLanguage === languageType.ORIGIN && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <div className={classes.displayFlex}>
                        <div className={classes.divHelp}>
                          <AnyButton />
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpExpiration}
                        />
                        {helpExpiration && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CloseIcon
                                className={classes.helpCloseBtn}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography
                                  className={classes.explainExpirationTitle}
                                >
                                  期限指定
                                </Typography>
                                <Typography className={classes.textHelpExplain}>
                                  チケットを購入してから利用できる期限を設定できます。
                                  <br />
                                  例）30日間利用可能
                                </Typography>
                                <br />
                                <Typography
                                  className={classes.explainExpirationTitle}
                                >
                                  期間指定
                                </Typography>
                                <Typography className={classes.textHelpExplain}>
                                  チケットを購入してから利用できる期間（終了日）を設定できます。
                                  <br />
                                  例）〜3月31日まで
                                  <br />
                                  ※期間が180日を超える場合は、購入から180日以内に設定されます。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </Typography>
                    <Typography
                      component="div"
                      className={classes.divisionLabel}
                    >
                      利用期間
                    </Typography>
                    <RadioGroup
                      col
                      value={expirationType}
                      onChange={e => {
                        setExpirationType(parseInt(e.target.value, 10));
                        resetExpirationValue();
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="期限指定"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="期間指定"
                      />
                      <FormControlLabel
                        value={2}
                        control={<Radio color="primary" />}
                        label="指定しない"
                      />
                    </RadioGroup>
                    {expirationType === 0 && (
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          select
                          label="利用期間"
                          className={classes.textFieldLong}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={expiration}
                          onChange={e => {
                            setExpiration(e.target.value);
                          }}
                          // onBlur={validExpiration}
                        >
                          {expirationList.map(item => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                        <ValidationText message={errors.expirationError} />
                      </Typography>
                    )}
                    {expirationType === 1 && (
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          label="終了"
                          type="date"
                          className={classes.textFieldLong}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={expirationEndDate}
                          inputProps={{
                            min: minExpirationDate,
                            max: maxExpirationDate
                          }}
                          onChange={e => {
                            setExpirationEndDate(e.target.value);
                          }}
                        />
                      </Typography>
                    )}
                  </ListItem>
                )}
              </>
            )}
            {isLanguage === languageType.ORIGIN && (
              <>
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      id="price"
                      disabled={comboMenu === 1}
                      required
                      label={isFukuoka ? '金額' : '価格'}
                      className={classes.textField}
                      margin="normal"
                      value={price}
                      onChange={e => {
                        setPrice(e.target.value.trim());
                        calcPrice(e);
                      }}
                      onBlur={validPrice}
                    />
                    <ValidationText message={errors.priceError} />
                    <div className={classes.priceCalc}>{priceCalc}</div>
                    {isFukuoka && (
                      <div className={classes.fukuokaTextPrice}>
                        ※10,000円以内の金額を入力してください
                      </div>
                    )}
                  </Typography>
                </ListItem>
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <div>
                      <TextField
                        id="taxType"
                        name="taxType"
                        select
                        label={isFukuoka ? '税区分*' : '税区分・寄付*'}
                        className={classes.textField}
                        margin="normal"
                        value={taxType}
                        onChange={e => {
                          setTaxType(e.target.value.trim());
                          calcPrice(e);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      >
                        {isFukuoka
                          ? taxTypes
                              .filter(group => {
                                return group.id !== 'DONATION';
                              })
                              .map(group => {
                                return (
                                  <MenuItem key={group.id} value={group.id}>
                                    {group.name}
                                  </MenuItem>
                                );
                              })
                          : taxTypes.map(group => {
                              return (
                                <MenuItem key={group.id} value={group.id}>
                                  {group.name}
                                </MenuItem>
                              );
                            })}
                      </TextField>
                    </div>
                    {!isFukuoka && (
                      <FormControlLabel
                        control={<Checkbox id="reducedTax" color="primary" />}
                        label="軽減税率対象"
                        checked={reducedTaxCheck}
                        onChange={e => {
                          setReducedTaxCheck(e.target.checked);
                          convertReducedTax(e.target.checked);
                          calcPrice(e);
                        }}
                      />
                    )}
                  </Typography>
                </ListItem>
                {!isFukuoka && (
                  <>
                    <ListItem className={classes.itemForm}>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        <RequiredButton />
                      </Typography>
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          required
                          select
                          label="ジャンル"
                          className={classes.textField}
                          margin="normal"
                          value={menuGenreId}
                          onChange={e => {
                            setMenuGenreId(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          onBlur={validMenuGenre}
                        >
                          {menuGenre &&
                            menuGenre.map(item => {
                              return (
                                <MenuItem
                                  key={item.menuGenreId}
                                  value={item.menuGenreId}
                                >
                                  {item.menuGenreName}
                                </MenuItem>
                              );
                            })}
                        </TextField>
                        <ValidationText message={errors.menuGenreError} />
                      </Typography>
                    </ListItem>
                    <ListItem className={classes.itemForm}>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        <AnyButton />
                      </Typography>
                      <Typography component="div" className={classes.formInput}>
                        <FormControl className={classes.situationPulldown}>
                          <InputLabel id="situation-label">
                            シチュエーション
                          </InputLabel>
                          <Select
                            labelId="situation-label"
                            multiple
                            value={menuSituationIds}
                            onChange={e => setmenuSituationIds(e.target.value)}
                            input={<Input />}
                            renderValue={() => getSituationName()}
                            className={classes.textFieldLong}
                            MenuProps={{
                              classes: { paper: classes.pulldownHeight },
                              getContentAnchorEl: null
                            }}
                          >
                            {menuSituation &&
                              menuSituation.map(situation => (
                                <MenuItem
                                  key={situation.menuSituationId}
                                  value={situation.menuSituationId}
                                >
                                  <Checkbox
                                    checked={
                                      menuSituationIds.indexOf(
                                        situation.menuSituationId
                                      ) > -1
                                    }
                                  />
                                  <ListItemText
                                    primary={situation.menuSituationName}
                                  />
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Typography>
                    </ListItem>
                    <ListItem className={classes.itemForm}>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        <AnyButton />
                      </Typography>
                      <Typography component="div" className={classes.formInput}>
                        <FormControl className={classes.situationPulldown}>
                          <InputLabel id="user-target-label">
                            贈り相手
                          </InputLabel>
                          <Select
                            labelId="user-target-label"
                            multiple
                            value={menuUserTargetIds}
                            onChange={e => setmenuUserTargetIds(e.target.value)}
                            input={<Input />}
                            renderValue={() => getUserTargetName()}
                            className={classes.textFieldLong}
                            MenuProps={{
                              classes: { paper: classes.pulldownHeight },
                              getContentAnchorEl: null
                            }}
                          >
                            {menuUserTarget &&
                              menuUserTarget.map(target => (
                                <MenuItem
                                  key={target.menuUserTargetId}
                                  value={target.menuUserTargetId}
                                >
                                  <Checkbox
                                    checked={
                                      menuUserTargetIds.indexOf(
                                        target.menuUserTargetId
                                      ) > -1
                                    }
                                  />
                                  <ListItemText primary={target.name} />
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Typography>
                    </ListItem>
                  </>
                )}
              </>
            )}
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <AnyButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  label="説明"
                  multiline
                  rows="4"
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 1000 : 2500
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  className={classes.textFieldLong}
                  margin="normal"
                  onChange={e => {
                    setDescription(e.target.value);
                  }}
                  value={description}
                />
              </Typography>
            </ListItem>
            {isLanguage === languageType.ORIGIN && (
              <>
                {!isFukuoka && (
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        label="タグ"
                        className={classes.textFieldLong}
                        margin="normal"
                        value={tagStr}
                        onChange={e => {
                          setTagStr(e.target.value);
                          splitTagStr(e.target.value);
                        }}
                      />
                    </Typography>
                    <Typography component="div" className={classes.textExplain}>
                      #おすすめ #おふくろの味 #学生に ＃ガッツリ
                      などメニューの特徴を表すタグを記載できます。
                    </Typography>
                  </ListItem>
                )}
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <AnyButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <FileUpload
                      label="image"
                      setFile={setImage}
                      previewImage={previewImage}
                      setPreviewImage={setPreviewImage}
                    />
                    <div className={classes.textExplain}>
                      ※8MB以内でお願いします。
                    </div>
                  </Typography>
                </ListItem>
              </>
            )}
          </List>
        </Paper>
        <div className={classes.btnBtom}>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddConfirm} className={classes.modalMobile}>
          <GochiMenuAddConfirmShop
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            openAddProgress={openAddProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            roles={roles}
            groups={groups}
            shopName={shopName}
            currentLanguage={isLanguage}
            menuGenreName={menuGenreName}
            menuSituationNames={menuSituationNames}
            menuUserTargetNames={menuUserTargetNames}
            isFukuoka={isFukuoka}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
